import { render, staticRenderFns } from "./ProductSectionForm.vue?vue&type=template&id=7af0e3d8"
import script from "./ProductSectionForm.vue?vue&type=script&lang=js"
export * from "./ProductSectionForm.vue?vue&type=script&lang=js"
import style0 from "./ProductSectionForm.vue?vue&type=style&index=0&id=7af0e3d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports